<div class="min-h-screen bg-brand-night text-brand-ice">
    <app-nav-bar class="sticky top-0 z-50 h-16 min-h-16" style="block-size: var(--nav-h);"></app-nav-bar>

    <div class="relative flex min-h-screen flex-col" style="padding-top: var(--nav-h);">
        <main class="flex-1">
            <router-outlet></router-outlet>
        </main>

        <app-footer class="min-h-[200px]"></app-footer>
    </div>

    <app-version-panel class="pointer-events-none fixed bottom-6 right-6 z-30"></app-version-panel>
</div>
